module.exports = __webpack_public_path__ + "1a240b42a550c9340cc61df07dcaf0ae.woff2";